import { render, staticRenderFns } from "./AmenitiesLocation.vue?vue&type=template&id=44d1d2dd"
import script from "./AmenitiesLocation.vue?vue&type=script&lang=js"
export * from "./AmenitiesLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports